import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';


@Component({
  selector: 'description-modal',
  templateUrl: './description-modal.component.html',
  styleUrls: ['./description-modal.component.scss'],
})
export class DescriptionModalComponent {
  @Input() descriptions: any[] = [];
  @Input() title: string = 'Activity Information';

  public currentHeaderData: any = {
    modalSlotEnd: true,
    title: '',
    marl20: true,
    mart4: true,
  };

  constructor(private modalController: ModalController) {}

  ngOnInit(): void {
    this.currentHeaderData = {
      ...this.currentHeaderData,
      title: this.title,
    };
  }

  closeModal(): void {
    this.modalController.dismiss();
  }
}
